import { getStoreId } from "$/hooks/use-store-information"
import discountCodeQueries from "$/lib/queries/discount-code-queries"
import { requireNonFreeTier } from "$/lib/require-non-free-tier"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/rabattkoder")({
  loader: async ({ context: { queryClient } }) => {
    await requireNonFreeTier(queryClient)
    const storeId = await getStoreId()
    if (storeId) {
      queryClient.prefetchQuery(discountCodeQueries.list({ storeId }))
      queryClient.prefetchQuery(discountCodeQueries.stats(storeId))
    }
    return {
      crumbs: "alfred.pages.discountCodes.crumbs.discountCodes",
    }
  },
})
